













































import Component from 'vue-class-component';
import BaseComponent from '../BaseComponent';

@Component({
  props: {
    labelKey: String,
    valueKey: String,
    options: {
      type: Array,
      default: Array,
    },
    returnFullSelectObject: {
      type: Boolean,
      default: false,
    },
    initialValue: [String, Number, Object, Function],
    placeholder: String,
    disabled: Boolean,
  },
})
export default class Dropdown extends BaseComponent {
  value: any | null = null;

  get selectOptions(): any {
    const options = [...this.$props.options];
    const valueKey = this.$props.valueKey;
    const labelKey = this.$props.labelKey;

    if (this.valueIsDefaultAndFalsey) {
      const defaultOption = {} as any;
      defaultOption[valueKey] = this.value;
      defaultOption[labelKey] = 'Selecteer een waarde';
      options.splice(0, 0, defaultOption);
    }

    return options;
  }

  get valueIsDefaultAndFalsey(): boolean {
    const isInitialValue =
      JSON.stringify(this.$props.initialValue) === JSON.stringify(this.value);
    const isMinusOne = JSON.stringify(this.value) === JSON.stringify(-1);

    return isInitialValue && (!this.value || isMinusOne);
  }

  mounted(): void {
    this.value = this.$props.initialValue ?? null;
  }

  emitChange(): void {
    this.$emit('input', this.value);
    this.$emit('change', this.value);
  }
}
